import { render, staticRenderFns } from "./teacherStatis.vue?vue&type=template&id=073db15b&scoped=true"
import script from "./teacherStatis.vue?vue&type=script&lang=js"
export * from "./teacherStatis.vue?vue&type=script&lang=js"
import style0 from "./teacherStatis.vue?vue&type=style&index=0&id=073db15b&prod&lang=scss&scoped=true"
import style1 from "./teacherStatis.vue?vue&type=style&index=1&id=073db15b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073db15b",
  null
  
)

export default component.exports